import { FormEvent, useState } from 'react';
import { ErrorMessage, buttonClass, inputClass } from './ModerationUi';

export function ModerationLogin({
  onLogin,
}: {
  onLogin: (username: string, password: string) => Promise<void>;
}): JSX.Element {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);
    setIsSubmitting(true);
    try {
      await onLogin(username, password);
    } catch (reason) {
      setError(reason);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="mx-auto w-full max-w-md px-4 py-10 sm:px-6">
      <form onSubmit={submit} className="space-y-5 rounded-lg border border-border bg-card p-6">
        <div>
          <h1 className="text-2xl font-semibold">Вход для проверяющих</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Аккаунты создаёт администратор Webstat. Публичной регистрации нет.
          </p>
        </div>
        {error ? <ErrorMessage error={error} /> : null}
        <label className="block space-y-2">
          <span className="text-sm font-medium">Имя пользователя</span>
          <input
            className={inputClass}
            autoComplete="username"
            required
            value={username}
            onChange={(event) => setUsername(event.target.value)}
          />
        </label>
        <label className="block space-y-2">
          <span className="text-sm font-medium">Пароль</span>
          <input
            className={inputClass}
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        <button className={`${buttonClass} w-full`} type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Вход…' : 'Войти'}
        </button>
      </form>
    </main>
  );
}
